import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Github, Linkedin, Mail, Youtube } from 'lucide-react';
import { servicePages } from '@/lib/service-pages';

const VisitorCounter = () => {
  const { t } = useTranslation();
  const [visitors, setVisitors] = useState(0);

  useEffect(() => {
    // Get visitors from localStorage or initialize
    const storedVisitors = localStorage.getItem('portfolio_visitors');
    const count = storedVisitors ? parseInt(storedVisitors) + 1 : 1;
    localStorage.setItem('portfolio_visitors', count.toString());
    setVisitors(count);
  }, []);

  return (
    <div className="text-center text-xs text-muted-foreground py-4">
      {t('footer.totalVisitors')} <span className="font-semibold text-primary">{visitors}</span>
    </div>
  );
};

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-card border-t border-border py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-4">
          <p className="text-muted-foreground text-sm">{t('footer.rights', { year: new Date().getFullYear() })}</p>
          <nav className="flex gap-4" aria-label="Social media links">
            <a
              href="https://www.linkedin.com/in/ahmad-abid-1a57a3227/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label={t('footer.linkedinAria')}
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://github.com/khanyousafzaideveloper"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label={t('footer.githubAria')}
            >
              <Github className="h-5 w-5" />
            </a>
            <a
              href="https://www.youtube.com/channel/UC8AnRxepLtQLel8TBFVntvw"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label={t('footer.youtubeAria')}
            >
              <Youtube className="h-5 w-5" />
            </a>
            <a
              href="mailto:ahmadyousafzai30@gmail.com"
              className="text-muted-foreground hover:text-primary transition-colors"
              aria-label={t('footer.emailAria')}
            >
              <Mail className="h-5 w-5" />
            </a>
          </nav>
        </div>
        <nav aria-label="Services" className="flex flex-wrap justify-center gap-x-6 gap-y-2 pt-2 border-t border-border">
          {servicePages.map((page) => (
            <Link
              key={page.slug}
              to={`/services/${page.slug}`}
              className="text-xs text-muted-foreground hover:text-primary transition-colors mt-3"
            >
              {page.label}
            </Link>
          ))}
        </nav>
        <VisitorCounter />
      </div>
    </footer>
  );
};

export default Footer;
